import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {PaginationStripe} from '@pb/kit-component-pagination';

import {MCP_LIMIT_LOG_PAGE_SIZES} from './constants';
import {
    mcpLimitLogStateActions,
    mcpLimitLogStateSelector,
} from './slices/mcp-limit-log-state.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const McpLimitLogPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(mcpLimitLogStateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(mcpLimitLogStateActions.setPageSize(pageSize));
        dispatch(mcpLimitLogStateActions.setCurrentPage(1));
    }, [dispatch]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(mcpLimitLogStateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={MCP_LIMIT_LOG_PAGE_SIZES}
        />
    );
};
